import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Check, Crown, Zap, Download, ShieldCheck } from 'lucide-react';
export function AmazonMasterSystem() {
  const includes = ['Amazon FBA Desde Cero (2026)', 'Amazon FBM Desde Cero (2026)', 'Amazon Wholesale Desde Cero (2026)', 'Software Stack Amazon™', 'Amazon Arbitrage Master™'];
  return <section className="bg-brand-beige py-20 md:py-24 px-5 sm:px-6" data-id="element-38">
      <div className="max-w-5xl mx-auto" data-id="element-39">
        <FadeIn data-id="element-40">
          <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-brand-green via-[#102b1e] to-brand-green border-2 border-brand-gold/50 shadow-[0_30px_80px_-20px_rgba(28,57,40,0.6)]" data-id="element-41">
            {/* Top gold accent line */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent" data-id="element-42"></div>

            <div className="p-8 sm:p-10 md:p-12" data-id="element-43">
              {/* Badge */}
              <div className="flex justify-center mb-5" data-id="element-44">
                <span className="inline-flex items-center gap-2 bg-brand-gold text-brand-green text-xs font-bold tracking-[0.15em] uppercase px-4 py-1.5 rounded-full shadow-lg" data-id="element-45">
                  <Crown className="w-3.5 h-3.5" data-id="element-46" />
                  La opción más completa
                </span>
              </div>

              {/* Title + subtitle */}
              <div className="text-center mb-8" data-id="element-47">
                <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight leading-[1.1] mb-3" data-id="element-48">
                  🚀 AMAZON MASTER SYSTEM™ 2026
                </h2>
                <p className="text-base md:text-lg text-white/70" data-id="element-49">
                  Todo el ecosistema Amazon en un solo sistema.
                </p>
              </div>

              {/* Main cover image */}
              <div className="flex justify-center mb-8" data-id="element-50">
                <div className="group w-[80%] sm:w-[75%] rounded-2xl overflow-hidden ring-1 ring-brand-gold/25 shadow-[0_25px_70px_-15px_rgba(0,0,0,0.6)]" data-id="element-51">
                  <img src="https://cdn.magicpatterns.com/uploads/sTWKrgTk8pMdf3AQmJ9XJC/ChatGPT_Image_16_jun_2026,_20_06_18.png" alt="Amazon Master System™ 2026 - Todo el ecosistema Amazon en un solo sistema" loading="lazy" className="w-full h-auto object-contain transition-transform duration-500 ease-out group-hover:scale-[1.04]" data-id="element-52" />
                </div>
              </div>

              {/* Includes table */}
              <div className="rounded-2xl border border-brand-gold/25 bg-white/5 overflow-hidden mb-8" data-id="element-53">
                <div className="px-5 py-3 border-b border-white/10 bg-white/5" data-id="element-54">
                  <p className="text-xs font-bold tracking-[0.15em] uppercase text-brand-gold" data-id="element-55">
                    📦 Incluye
                  </p>
                </div>
                <div className="divide-y divide-white/10" data-id="element-56">
                  {includes.map((item, i) => <div key={i} className="flex items-center justify-between px-5 py-3.5" data-id="element-57">
                      <span className="text-sm sm:text-base font-medium text-white/90" data-id="element-58">
                        {item}
                      </span>
                      <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-brand-gold/20 flex-shrink-0" data-id="element-59">
                        <Check className="w-3 h-3 text-brand-gold" strokeWidth={3.5} data-id="element-60" />
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Softwares incluidos */}
              <div className="mb-8" data-id="element-61">
                <p className="text-center text-xs font-bold tracking-[0.15em] uppercase text-brand-gold mb-4" data-id="element-62">
                  🛠 Softwares incluidos
                </p>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-63">
                  {[{
                  name: '📈 Keepa',
                  desc: 'Historial de precios y demanda.'
                }, {
                  name: '📊 RevSeller',
                  desc: 'Análisis rápido de rentabilidad.'
                }, {
                  name: '🎯 SmartScout',
                  desc: 'Investigación avanzada de productos y marcas.'
                }, {
                  name: '⚡ Seller Snap',
                  desc: 'Automatización y optimización de precios.'
                }].map((sw, i) => <div key={i} className="rounded-xl border border-brand-gold/25 bg-white/5 p-4 text-center" data-id="element-64">
                      <p className="text-sm font-bold text-white mb-1" data-id="element-65">
                        {sw.name}
                      </p>
                      <p className="text-xs text-white/55 leading-snug" data-id="element-66">
                        {sw.desc}
                      </p>
                    </div>)}
                </div>
              </div>

              {/* Price */}
              <div className="text-center mb-7" data-id="element-67">
                <div className="flex items-baseline justify-center gap-3 mb-1" data-id="element-68">
                  <p className="text-5xl sm:text-6xl font-bold text-white tracking-tight leading-none" data-id="element-69">
                    $39.99
                  </p>
                  <p className="text-xl sm:text-2xl line-through font-semibold text-white/35" data-id="element-70">
                    $79.99
                  </p>
                </div>
                <p className="text-xs font-bold text-brand-gold uppercase tracking-wider mt-2" data-id="element-71">
                  🔥 Precio de lanzamiento — pago único
                </p>
              </div>

              {/* Button */}
              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/amazon-master-system%E2%84%A2-2026-fba-fbm-wholesale-bonos-premium', '_blank', 'noopener,noreferrer')} className="w-full bg-brand-gold hover:bg-brand-gold/90 text-brand-green text-base md:text-lg font-bold py-5 shadow-lg shadow-brand-gold/30" data-id="element-72">
                🚀 QUIERO AMAZON MASTER SYSTEM™
              </Button>

              {/* Trust badges */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-white/50 text-xs mt-6" data-id="element-73">
                <span className="flex items-center gap-1.5 tracking-wide" data-id="element-74">
                  <Zap className="w-3.5 h-3.5 text-brand-gold" data-id="element-75" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5 tracking-wide" data-id="element-76">
                  <Download className="w-3.5 h-3.5 text-brand-gold" data-id="element-77" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5 tracking-wide" data-id="element-78">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-gold" data-id="element-79" />
                  COMPRA SEGURA
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}